import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string
}

// 登录
export const loginApi = (data: UserType): Promise<IResponse<UserType>> => {
  return request.post({ url: '/api/login', data })
}

// 获取用户信息
export const getUserInfoApi = (): Promise<IResponse> => {
  return request.post({ url: '/api/getUserInfo' })
}

// 登出
export const loginOutApi = (): Promise<IResponse> => {
  return request.post({ url: '/api/logout' })
}

// 菜单权限
export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.post({ url: '/api/getMenuList', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
